import { FC, Suspense, useState } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import { AssignmentMonitoringQuery } from '../../graphQLOperations/__generated__/AssignmentMonitoringQuery.graphql';
import { getAssignmentReport } from '../../graphQLOperations/Assignment';
import { AssignmentCardStudentListModal } from './AssignmentCardStudentListModal';
import { isOnlyTargetAssignment } from '../../businessLogicService/AssignmentsAux/isOnlyTargetAssignment';
import { AssignmentStudentPercentageCard } from './AssignmentStudentPercentageCard';
import {
  cardReferencesSupport,
  cardReferencesTarget,
  StudentQueryKeys,
} from '../../businessLogicService/AssignmentsAux/StudentQueryKeys';

interface Props {
  queryReference: PreloadedQuery<AssignmentMonitoringQuery, Record<string, unknown>>;
  assignmentId: string;
}

export interface CardReference {
  key: string;
  label: string;
  icon: string;
  studentQueryKey: StudentQueryKeys;
}

export const AssignmentMonitoringCards: FC<Props> = ({ queryReference, assignmentId }) => {
  const [selectedCard, setSelectedCard] = useState<CardReference | null>(null);
  const { assignmentProgressPercentages, assignment } = usePreloadedQuery<AssignmentMonitoringQuery>(
    getAssignmentReport,
    queryReference,
  );

  return (
    <div className=" pt-3 bg-white h-20rem border-round-xl ">
      <div className="flex justify-content-center">
        <div className="pt-5">
          <h4 className="text-center text-lg font-semibold mb-3">Target Skill:</h4>
          <div className="flex">
            {cardReferencesTarget.map(ref => (
              <AssignmentStudentPercentageCard
                key={ref.label}
                cardInfo={ref}
                setSelectedCard={setSelectedCard}
                assignmentProgressPercentages={assignmentProgressPercentages[ref.key as keyof object]}
              />
            ))}
          </div>
        </div>
        {!isOnlyTargetAssignment(
          assignment?.skill?.id,
          assignment?.studentSkillAssignments?.map(item => item?.skill?.id || ''),
        ) && (
          <div className="ml-6 pt-5">
            <h4 className="text-center text-lg font-semibold mb-3">{`Support Skill(s):`}</h4>
            <div className="flex">
              {cardReferencesSupport.map(ref => (
                <AssignmentStudentPercentageCard
                  key={ref.label}
                  cardInfo={ref}
                  setSelectedCard={setSelectedCard}
                  assignmentProgressPercentages={assignmentProgressPercentages[ref.key as keyof object]}
                />
              ))}
            </div>
          </div>
        )}
      </div>

      <div className="block col-12">
        <p className="text-center w-full my-2 text-800">
          Note: An assignment is marked as <span className="font-semibold">Completed</span> once the{' '}
          <span className="font-semibold">student submits an assessment</span> for the assigned skill{`(s)`}.
        </p>
      </div>
      {selectedCard && (
        <Suspense>
          <AssignmentCardStudentListModal
            setCardReference={setSelectedCard}
            cardReference={selectedCard}
            assignmentId={assignmentId}
          />
        </Suspense>
      )}
    </div>
  );
};
